// extracted by mini-css-extract-plugin
export var container = "code-module--container--ddc5a";
export var copy = "code-module--copy--7dd40";
export var lang = "code-module--lang--1a168";
export var output = "code-module--output--afc0d";